interface NetworkInformation {
  downlink: number;
  effectiveType: string;
}

export function getConnectionInfo() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if ('connection' in navigator && (navigator as any).connection) {
    const connection = navigator.connection as NetworkInformation;
    return {
      downlink: connection.downlink,
      effectiveType: connection.effectiveType,
    };
  }
  return null; // Not supported
}
